import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SupportUserRoutingModule } from './support-user-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SupportUserRoutingModule
  ]
})
export class SupportUserModule { }
